import {ComponentEntity} from "./component-entity";
import {MunicipalityResponse, NeighborhoodsResponse, StatesResponse} from "../network/sepomex/sepomex.response";


export interface ProjectItem {
  id_application: number;
  id_cia: number;
  status: number;
  application_name: string;
  application_description: string;
  id_app_google: string;
  icon: string;
  icon_qr: string;
  url_qr: string;
  version: string;

}
export interface PersonalInformation {
  showTypesData: string[];
  urlImage: string;
  title: string;
  locationInformation: LocationInformation;
  active: boolean;
}

export interface LocationInformation {
  state: StatesResponse;
  municipality:MunicipalityResponse
  neighborhoods:NeighborhoodsResponse
}


export interface ApplicantProject {
  status: ApplicantProjectStatus;
  appId: string;
  preconfiguration: Preconfiguration;
  views: ApplicantProjectLayout[];
  personalInformation: PersonalInformation;

}

export interface Preconfiguration {
  urlAnalytics: string;
  offline: boolean;
  urlSound: string;
  interceptorPhone: string[];
  showState: boolean;
  activeGeoLocalization: boolean;
  tagAnalyticOpen: '',

  welcomeVideo: string;

}

export enum TypeInputPersonalInformation {
  NAME = 'Nombre',
  PHONE = 'Telefono',
  EMAIL = 'Correo',
  LOCALIZATION_CONFIGURATION = 'Localizacion',
}

export interface ApplicantProjectLayout {
  id: string;
  nameView: string;
  mainView: boolean;
  component: ComponentEntity[];
}

export enum ApplicantProjectStatus {
  ACTIVE,
  DISABLE,
}
